import {Component, ChangeDetectionStrategy} from '@angular/core';
import {SeparatorComponent} from '@/app/shared/components/separator/separator.component';
import {AsyncPipe} from '@angular/common';
import {AchievementRowComponent} from '@components/achievement-row/achievement-row.component';
import {UpcomingMatchsComponent} from '@components/upcoming-matchs/upcoming-matchs.component';
import {TitleComponent} from '@/app/shared/components/title/title.component';
import {TranslatePipe} from '@ngx-translate/core';
import {LastVideosComponent} from '@components/last-videos/last-videos.component';
import {
	MemberMarvelRivalsCardComponent
} from '@components/member-marvel-rivals-card/member-marvel-rivals-card.component';

@Component({
  selector: 'app-roster-pokemon-unite',
	imports: [
		SeparatorComponent,
		AsyncPipe,
		AchievementRowComponent,
		UpcomingMatchsComponent,
		TitleComponent,
		TranslatePipe,
		LastVideosComponent,
		MemberMarvelRivalsCardComponent
	],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './roster-pokemon-unite.component.html',
})
export class RosterPokemonUniteComponent {
	protected readonly storyBlocks = [
		{label: 'page.roster-pokemon-unite.story-1.label', text: 'page.roster-pokemon-unite.story-1.text', image: '/assets/images/unite/unite_2.jpg', year: '2023'},
		{label: 'page.roster-pokemon-unite.story-2.label', text: 'page.roster-pokemon-unite.story-2.text', image: '/assets/images/unite/unite_3.jpg', year: '2026'},
	];
}
